export const UNDER_EXTERNAL_ADMINISTRATION = 'under-external-administration';
